import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { LoansApi } from '../tokens/loans.token';
import {
  LenderExposure,
  LoanCard,
  LoanDetail,
  LoanKpis,
  RepaymentScheduleView,
} from '../models/financing-servicing.model';

/**
 * REST-only implementation of `LoansApi` (EPIC-4 / EM-500, Story 10 — EM-510).
 *
 * Calls the Story-4 `LoanResource` (loan-id-keyed reads) under `/services/embedded/api/loans`.
 * Rides the Keycloak bearer (attached by `authInterceptor`). Rule 07 / Rule 10 — no Mock. Rule 09 —
 * the raw `HttpErrorResponse` propagates for surfacing.
 */
@Injectable()
export class LoansRestService implements LoansApi {
  private readonly http = inject(HttpClient);

  list(status?: string): Observable<LoanCard[]> {
    let params = new HttpParams();
    if (status) {
      params = params.set('status', status);
    }
    return this.http.get<LoanCard[]>(API_PATHS.LOANS, { params });
  }

  exposure(): Observable<LenderExposure[]> {
    return this.http.get<LenderExposure[]>(`${API_PATHS.LOANS}/exposure`);
  }

  kpis(): Observable<LoanKpis> {
    return this.http.get<LoanKpis>(`${API_PATHS.LOANS}/kpis`);
  }

  detail(loanId: string): Observable<LoanDetail> {
    return this.http.get<LoanDetail>(`${API_PATHS.LOANS}/${encodeURIComponent(loanId)}`);
  }

  schedule(loanId: string): Observable<RepaymentScheduleView> {
    return this.http.get<RepaymentScheduleView>(`${API_PATHS.LOANS}/${encodeURIComponent(loanId)}/schedule`);
  }
}
